import { getHeaders, SubmissionURL } from './config';
import { checkStatus } from './normalizer';
import { CarrierTreatyYear } from '../types/carrier.types';
import { throwIfDateOverlap } from '../helpers/dateOverlapError';

export async function getCurrentTreatiesData(): Promise<CarrierTreatyYear[]> {
    const url = `${SubmissionURL}/carrier-treaty-year/active`;
    const options = {
        method: 'GET',
        headers: getHeaders(),
    };
    return fetch(url, options)
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function getAllTreatiesData(productLineType?: string): Promise<CarrierTreatyYear[]> {
    const url = `${SubmissionURL}/carrier-treaty-year${productLineType ? '?productLineType=' + productLineType : ''}`;
    const options = {
        method: 'GET',
        headers: getHeaders(),
    };
    return fetch(url, options)
        .then(checkStatus)
        .then((resp) => resp.json());
}

export async function createCarrierTreatyYear(data: Partial<CarrierTreatyYear>): Promise<CarrierTreatyYear> {
    const resp = await fetch(`${SubmissionURL}/carrier-treaty-year`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    await throwIfDateOverlap(resp);
    return Promise.resolve(resp)
        .then(checkStatus)
        .then((r: Response) => r.json());
}

export async function updateCarrierTreatyYear(
    id: string,
    data: Partial<CarrierTreatyYear>
): Promise<CarrierTreatyYear> {
    const resp = await fetch(`${SubmissionURL}/carrier-treaty-year/${id}`, {
        method: 'PATCH',
        headers: getHeaders(),
        body: JSON.stringify(data),
    });
    await throwIfDateOverlap(resp);
    return Promise.resolve(resp)
        .then(checkStatus)
        .then((r: Response) => r.json());
}

export async function deleteCarrierTreatyYear(id: string): Promise<void> {
    return fetch(`${SubmissionURL}/carrier-treaty-year/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then(() => undefined);
}
